<script setup>
import { useRaaiMembersStore } from '@/store/raaiMembers'
import { onMounted, ref } from 'vue'

const raaiMembersStore = useRaaiMembersStore()
const raaiMembers = ref([])
const headers = ref([
    { title: 'ФИО', key: 'fullName' },
    { title: 'Региональное отделение', key: 'regionalBranch' }
])

onMounted(async () => {
    await raaiMembersStore.getRaaiMembers()
    raaiMembers.value = raaiMembersStore.formatRaaiMembers
    console.log(raaiMembers.value)
})
</script>
<template>
    <h1 class="title">ЧЛЕНЫ РАИИ</h1>
    <div class="table">
        <v-data-table
            items-per-page="-1"
            :headers="headers"
            :items="raaiMembers"
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td v-if="!item.isHidden">
                        <router-link
                            class="active-link"
                            :to="`/personalities/${item.userId}`"
                        >
                            {{ item.fullName }}
                        </router-link>
                    </td>
                    <td v-else>
                        {{ item.fullName }}
                    </td>
                    <td>{{ item.regionalBranch }}</td>
                </tr>
            </template>
            <template #bottom></template>
        </v-data-table>
    </div>
</template>

<style lang="scss" scoped>
a {
    text-decoration: none;
    color: #000;
}

.active-link {
    color: #0635ac;

    &:hover {
        text-decoration: underline;
    }
}

.title {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
    color: #0635ac;
    text-align: left;

    @media screen and (max-width: 767px) {
        font-size: 28px;
        line-height: 36px;
        text-align: left;
    }
}

.v-table {
    text-align: left;
    margin-top: 15px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;

    :deep(.v-table__wrapper) {
        table {
            thead {
                tr {
                    th {
                        font-weight: 600;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        font-size: 14px;
    }
}
</style>
